import $ from "jquery";
import React from "react";
import PropTypes from "prop-types";
import { produce } from "immer";
import classNames from "classnames";
import Select from "react-select";
import { NumericFormat } from "react-number-format";
import ButtonWithModal from "./button_with_modal";


const EBITDA_COMPUTED_KEY = "EBITDA_COMPUTED_KEY";
const COMPUTE_EBITDA = "compute_ebitda";
const INTEREST_INCOME = "interest_income";
const INTERESET_EXPENSES = "interest_expenses";
const DEPRECIATION = "depreciation";
const AMORTIZATION = "amortization";
const NET_INCOME_TAX_AFTER_TAX = "net_income_after_tax";
const INCOME_TAX = "income_tax";
const EBITDA_COMPONENT_KEYS_EDITABLE = [
  INTEREST_INCOME,
  INTERESET_EXPENSES,
  DEPRECIATION,
  AMORTIZATION,
  INCOME_TAX,
];
const EBITDA_COMPUTATION_FIELDS = EBITDA_COMPONENT_KEYS_EDITABLE.concat(NET_INCOME_TAX_AFTER_TAX);
const EBITDA_COMPONENT_KEYS = EBITDA_COMPONENT_KEYS_EDITABLE.concat(EBITDA_COMPUTED_KEY);

const EBITDA_COMPONENTS = [
  "Interest Income",
  "Interest Expenses",
  "Depreciation",
  "Amortization",
  "Income tax"
];

const ADD_PREVIOUS_YEAR = "ADD_PREVIOUS_YEAR";
const ADD_NEXT_YEAR = "ADD_NEXT_YEAR";
const CURRENCY_FLEX = 0.7;

const isEbitdaRow = row_key => row_key === "ebitda";
const nullUndefinedReplace = (e, replace="") => e === 0 || e ? e : replace;
const deletedRowKey = (row_key, categoryIndex) => `${row_key}-category-index-${categoryIndex}`;
const baseNS = inputName => `company_form[${inputName}]`;
const nsIndicator = (key, id, fieldName, fieldName2, fieldName3) => (
  `company_form[company_form_${key}_indicators_attributes][${id}][${nullUndefinedReplace(fieldName)}][${nullUndefinedReplace(fieldName2)}][${nullUndefinedReplace(fieldName3)}]`.replace(/\[\]/gi, "")
);
const indicatorStateId = ({ period, categoryIndex, year }) => `${nullUndefinedReplace(period)}-${nullUndefinedReplace(categoryIndex)}-${year}`;
const removeCalculatedFrom = (key) => key.replace(/\[calculated_from\]\[\w+\]/gi, "");
const yearFromKey = (key) => removeCalculatedFrom(key).split("[").slice(-2)[0].split("-").slice(-1)[0].replace("]", "");

const FY = "fy";
const PERIODS = [
  "q1",
  "q2",
  "h1",
  "q3",
  "q4",
  "h2",
];

const GLOBAL_INPUT_NAMES = {
  global_multiplier: "global_multiplier",
  financial_year_end_day_month: baseNS("financial_year_end_day_month"),
  size_range: baseNS("size_range"),
  override_indicator_size_range: baseNS("override_indicator_size_range"),
  top_level_revenue_range: baseNS("top_level_revenue_range"),
  override_indicator_top_level_revenue_range: baseNS("override_indicator_top_level_revenue_range"),
  default_currency_id: "default_currency_id",
  custom_conversion_factor: "custom_conversion_factor",
  currency_conversion_factor: "currency_conversion_factor",
  size_description: baseNS("size_description"),
};
const defaultCurrencyKey = year => `${GLOBAL_INPUT_NAMES.default_currency_id}[${year}]`;

const GLOBAL_MULTIPLIER_OPTIONS = [
  {
    value: 1,
    label: "x1"
  },
  {
    value: 1000,
    label: "x10³"
  },
  {
    value: 1000000,
    label: "x10⁶"
  },
  {
    value: 1000000000,
    label: "x10⁹"
  }
];

const INDICATOR_FIELD_NAMES = [
  "indicator_unit_original_id",
  "value_original",
  "value_processed",
];
const INDICATOR_FIELD_NAME_MAP = INDICATOR_FIELD_NAMES.reduce((a, e) => (a[e] = e) && a, {});

const VALUE_ORIGINAL = "value_original";
const INDICATOR_UNIT_ORIGINAL_ID = "indicator_unit_original_id";
const VALUE_PROCESSED = "value_processed";
const CATEGORY = "category";
const YEAR = "year";
const PERIOD = "period";
const NOTES = "notes";
const ERRORS = "errors";
const CATEGORY_INDEX = "categoryIndex";

const SIZE_RANGE = "size_range";
// const TOP_LEVEL_REVENUE_RANGE = "top_level_revenue_range";
const SIZE_DESCRIPTION = "size_description";

const INDICATOR_FIELDS = [
  "id",
  CATEGORY_INDEX,
  VALUE_ORIGINAL,
  INDICATOR_UNIT_ORIGINAL_ID,
  VALUE_PROCESSED,
  CATEGORY,
  YEAR,
  PERIOD,
  NOTES,
  ERRORS,
  SIZE_RANGE,
  SIZE_DESCRIPTION,
];

const subRowToggleKey = (row_key) => `SEGMENT_${row_key}`;

const waterRevenueToSizeRangeValue = (value) => {
  if (!value) {
    return;
  }

  if (value < 10000000) {
    return "lt_ten";
  } else if (value <= 50000000) {
    return "ten_fifty";
  } else if (value <= 200000000) {
    return "fifty_two_hundred";
  } else if (value <= 1000000000) {
    return "two_hundred_one_bn";
  } else {
    return "over_one_bn";
  }
};

const segmentRowKey = row_key => row_key === "business_revenue_segment" || row_key === "geographic_revenue_segment";

/* eslint-disable react/prop-types */
class DataTds extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps) {
    const {
      year,
      row_key,
      rowPeriod,
      categoryIndex,
      deletedRow,
      rowCategory,
      ebitdaComponentKey,
    } = this.props;

    const id = indicatorStateId({ period: rowPeriod, categoryIndex, year });

    const currencyKey = nsIndicator(row_key, id, "indicator_unit_original_id");

    const valueOriginalKey = nsIndicator(row_key, id, (ebitdaComponentKey ? "calculated_from" : null), (ebitdaComponentKey || null), "value_original");
    const valueProcessedKey = nsIndicator(row_key, id, (ebitdaComponentKey ? "calculated_from" : null), (ebitdaComponentKey || null), "value_processed");
    const computeEbitdaKey = nsIndicator(row_key, id, "calculated_from", COMPUTE_EBITDA);

    const deletedOrRestored = deletedRow !== nextProps.deletedRow;
    const newCategoryName = rowCategory !== nextProps.rowCategory;
    const userEditableFieldsChanged = [currencyKey, valueOriginalKey, valueProcessedKey, computeEbitdaKey].some(k => this.props.inputs[k] !== nextProps.inputs[k]);
    return deletedOrRestored || newCategoryName || userEditableFieldsChanged;
  }

  render() {
    const {
      year,
      topLevelSegmentRow,
      indicatorForYear,
      getInputValue,
      rowPeriod,
      rowCategory,
      row_key,
      inputs,
      Input,
      SelectInput,
      currency_options,
      categoryIndex,
      deletedRow,
      ebitdaComponentKey,
    } = this.props;

    if (topLevelSegmentRow) {
      return <td key={year} />;
    }

    const indicator = indicatorForYear(year) || { period: rowPeriod, categoryIndex, year, errors: {} };

    const id = indicatorStateId(indicator);
    const nsI = (fieldName, fieldName2, fieldName3) => nsIndicator(row_key, id, fieldName, fieldName2, fieldName3);

    const computeEbitdaKey = nsIndicator(row_key, id, "calculated_from", COMPUTE_EBITDA);
    const ebitdaComputedRow = ebitdaComponentKey === EBITDA_COMPUTED_KEY;
    const currencyKey = nsI("indicator_unit_original_id");
    const valueOriginalKey = ebitdaComponentKey ? nsI("calculated_from", ebitdaComponentKey, "value_original") : nsI("value_original");
    const valueProcessedKey = ebitdaComponentKey ? nsI("calculated_from", ebitdaComponentKey, "value_processed") : nsI("value_processed");

    // no data has been entered in the user editable fields, therefore do not submit anything for this indicator
    const userVisibleData = inputs[valueOriginalKey] || inputs[valueProcessedKey];
    const indicatorId = indicator.id;
    const deletedCell = deletedRow || (indicatorId && !userVisibleData);
    const pristine = !userVisibleData && !deletedCell;


    const { errors } = indicator;
    const tds = [
      <td key={year} className={classNames({ "deleted-row-td": deletedRow })}>
        {
          !ebitdaComponentKey &&
          <div>
            <input
              name={pristine ? "" : nsI("_destroy")}
              value={deletedCell ? "1" : ""}
              type="hidden"
            />
            <Input
              doNotSubmit={pristine}
              name={nsI("id")}
              type="hidden"
            />
            <Input
              doNotSubmit={pristine}
              name={nsI("year")}
              value={year}
              type="hidden"
            />
            <Input
              doNotSubmit={pristine}
              name={nsI("period")}
              type="hidden"
              value={rowPeriod}
            />
            <Input
              doNotSubmit={pristine}
              name={nsI("unique_indicator_data_type_id")}
              type="hidden"
            />

            <Input
              doNotSubmit={pristine}
              name={nsI("category")}
              value={rowCategory}
              type="hidden"
            />

            <Input
              doNotSubmit={pristine}
              name={nsI("notes")}
              type="hidden"
            />

            <Input
              doNotSubmit={pristine}
              name={nsI("size_range")}
              value={waterRevenueToSizeRangeValue(getInputValue(valueProcessedKey))}
              type="hidden"
            />

            <Input
              doNotSubmit={pristine}
              name={nsI("size_range_description")}
              type="hidden"
            />
          </div>
        }

        <div className="d-flex">
          <div
            title={errors["indicator_unit_original_id"]}
            className={classNames({ hidden: !ebitdaComputedRow, "has-error": errors["indicator_unit_original_id"] })}
            style={{ flex: CURRENCY_FLEX }}
          >
            {
              !ebitdaComponentKey && <SelectInput
                name={currencyKey}
                options={currency_options}
                doNotSubmit={pristine}
                label=" "
              />
            }
            {
              ebitdaComputedRow &&
                <Input
                  name={computeEbitdaKey}
                  doNotSubmit={pristine}
                  type="boolean"
                  blankIfFalsy
                  label="Use?"
                />
            }
          </div>
          <div
            title={errors["value_original"]}
            className={classNames({ "has-error": errors["value_original"] || errors["indicator_unit_original_id"] })}
            style={{ flex: 1 }}
          >
            <Input
              doNotSubmit={pristine}
              name={valueOriginalKey}
              readOnly={ebitdaComputedRow}
              label="Local"
              type="number"
            />
          </div>
          <div
            title={errors["value_processed"]}
            className={classNames({ "has-error": errors["value_processed"] || errors["indicator_unit_original_id"] })}
            style={{ flex: 1 }}
          >
            <Input
              doNotSubmit={pristine}
              name={valueProcessedKey}
              readOnly={ebitdaComputedRow}
              label="USD"
              type="number"
            />
          </div>
        </div>
        {
          deletedRow &&
          <div className="deleted-row-overlay">&nbsp;</div>
        }
      </td>
    ];

    return tds;
  }
}
/* eslint-enable react/prop-types */

class Root extends React.Component {
  constructor(props) {
    super(props);

    const segments = {
      business_revenue_segment: [],
      geographic_revenue_segment: []
    };
    const state = {
      inputs: JSON.parse(JSON.stringify(props.inputs)),
      options: {
        years: props.options.years,
        rows: props.options.rows,
        segments,
      }
    };

    state.options.rows.map(({ row_key, existing_indicators }) => {
      existing_indicators.map((indicator) => {
        if (indicator.category && segmentRowKey(row_key)) {
          const { segments } = state.options;
          const row_segments = segments[row_key];
          let categoryIndex = row_segments.indexOf(indicator.category);
          if (categoryIndex === -1) {
            row_segments.push(indicator.category);
            categoryIndex = row_segments.length - 1;
          }

          indicator[CATEGORY_INDEX] = categoryIndex;
          if (indicator._destroy && (indicator.indicator_unit_original_id || indicator.value_original || indicator.value_processed)) {
            state.inputs[deletedRowKey(row_key, categoryIndex)] = "1";
          }
        }

        state.inputs[defaultCurrencyKey(indicator.year)] = state.inputs[defaultCurrencyKey(indicator.year)] || indicator.indicator_unit_original_id;

        INDICATOR_FIELDS.map(field_name => {
          const indicatorKey = nsIndicator(row_key, indicatorStateId(indicator), field_name);

          state.inputs[indicatorKey] = indicator[field_name];
        });

        if (indicator.calculated_from) {
          const computeEbitdaKey = nsIndicator(row_key, indicatorStateId(indicator), "calculated_from", COMPUTE_EBITDA);

          state.inputs[computeEbitdaKey] = indicator.calculated_from[COMPUTE_EBITDA];

          EBITDA_COMPONENT_KEYS.map(ebitda_component_key => {
            const calcFrom = indicator.calculated_from[ebitda_component_key];
            if (calcFrom) {
              const keyOrig = nsIndicator(row_key, indicatorStateId(indicator), "calculated_from", ebitda_component_key, "value_original");
              const keyProc = nsIndicator(row_key, indicatorStateId(indicator), "calculated_from", ebitda_component_key, "value_processed");

              state.inputs[keyOrig] = calcFrom["value_original"];
              state.inputs[keyProc] = calcFrom["value_processed"];
            }
          });
        }
      });
    });

    state.inputs[GLOBAL_INPUT_NAMES.global_multiplier] = 1;

    this.state = state;

    this.setInputValue = this.setInputValue.bind(this);
    this.getInputValue = this.getInputValue.bind(this);
    this.toggleInputValue = this.toggleInputValue.bind(this);
    this.getConversionFactorToUsd = this.getConversionFactorToUsd.bind(this);
    this.Input = this.Input.bind(this);
    this.SelectInput = this.SelectInput.bind(this);
    this.Row = this.Row.bind(this);
    this.addYear = this.addYear.bind(this);
    this.addSegment = this.addSegment.bind(this);
    this.setCategoryValue = this.setCategoryValue.bind(this);
  }

  componentDidMount() {
    $(".react-indicator-table-wrapper")[0].scrollLeft = 99999;
  }

  toggleInputValue(key, onlyFocus=false, button=false) {
    return (e) => {
      if (button) {
        e.preventDefault();
        e.stopPropagation();
      }

      if (onlyFocus) {
        return;
      }

      this.setState(
        produce((draft) => {
          if (draft.inputs[key] === "1") {
            draft.inputs[key] = "0";
          } else {
            draft.inputs[key] = "1";

            if (key.indexOf("calculated_from") > 0) {
              // company_form[company_form_ebitda_indicators_attributes][fy--2019][calculated_from][compute_ebitda]
              // company_form[company_form_ebitda_indicators_attributes][fy--2019][value_original]
              const indicatorKey = removeCalculatedFrom(key);
              const computedKey = key.replace(COMPUTE_EBITDA, EBITDA_COMPUTED_KEY);

              const indOrig = `${indicatorKey}[value_original]`;
              const indProc = `${indicatorKey}[value_processed]`;
              const computedOrig = `${computedKey}[value_original]`;
              const computedProc = `${computedKey}[value_processed]`;

              draft.inputs[indOrig] = draft.inputs[computedOrig];
              draft.inputs[indProc] = draft.inputs[computedProc];
            }
          }
        })
      );
    };
  }

  setCategoryValue(row_key, categoryIndex) {
    return ({ target: { value } }) => {
      this.setState(
        produce((draft) => {
          draft.options.segments[row_key][categoryIndex] = value;
        })
      );
    };
  }

  setInputValue(key, onlyFocus=false) {
    return ({ target: { value }}) => {
      this.setState(produce((draft) => {
        if (GLOBAL_INPUT_NAMES.custom_conversion_factor === key) {
          draft.inputs[GLOBAL_INPUT_NAMES.currency_conversion_factor] = value;
        }

        const splut = key.split("[");
        if (splut[1]) {
          const fieldName = splut.slice(-1)[0].replace("]", "");
          const isCalculatedFrom = splut.slice(-3)[0] && splut.slice(-3)[0].replace("]", "") === "calculated_from";
          // company_form[company_form_net_income_after_tax_indicators_attributes][fy--2019][value_original]
          const calculatedFromfield = isCalculatedFrom ? splut.slice(-2)[0].replace("]", "") : splut.slice(1)[0].replace("]", "").replace("company_form_", "").replace("_indicators_attributes", "");

          if (INDICATOR_FIELD_NAMES.indexOf(fieldName) > -1) {
            const globalMultiplier = draft.inputs[GLOBAL_INPUT_NAMES.global_multiplier];
            value = value * globalMultiplier;

            const year = yearFromKey(key);
            let conversionFactorToUsd = draft.inputs[GLOBAL_INPUT_NAMES.custom_conversion_factor];

            const currencyKey = removeCalculatedFrom(key).replace(fieldName, INDICATOR_FIELD_NAME_MAP.indicator_unit_original_id);

            let currencyId = fieldName === INDICATOR_FIELD_NAME_MAP.indicator_unit_original_id ? value : draft.inputs[currencyKey];
            const globalCurrencyId = draft.inputs[defaultCurrencyKey(year)];
            if (globalCurrencyId) {
              currencyId = globalCurrencyId;
              draft.inputs[currencyKey] = globalCurrencyId;
            }

            if (currencyId && !conversionFactorToUsd) {
              conversionFactorToUsd = this.getConversionFactorToUsd(year, currencyId);
            }

            const convertValue = (keyToUse, valueToUse) => {
              let other_value_field_name, multiply;
              if (fieldName === INDICATOR_FIELD_NAME_MAP.value_original || fieldName === INDICATOR_FIELD_NAME_MAP.value_processed) {
                if (fieldName === INDICATOR_FIELD_NAME_MAP.value_original) {
                  other_value_field_name = INDICATOR_FIELD_NAME_MAP.value_processed;
                  multiply = false;
                } else if (fieldName === INDICATOR_FIELD_NAME_MAP.value_processed) {
                  other_value_field_name = INDICATOR_FIELD_NAME_MAP.value_original;
                  multiply = true;
                }

                const otherKey = keyToUse.replace(fieldName, other_value_field_name);

                draft.inputs[otherKey] = valueToUse ? (multiply ? (valueToUse * conversionFactorToUsd) : (valueToUse / conversionFactorToUsd)) : "";
              }
            };
            if (!onlyFocus && EBITDA_COMPUTATION_FIELDS.indexOf(calculatedFromfield) > -1) {
              const netIncomeFieldName = calculatedFromfield === NET_INCOME_TAX_AFTER_TAX;
              // run the computation and populate original or processed COMPUTED
              const net_income_after_tax = netIncomeFieldName ? value : draft.inputs[removeCalculatedFrom(key).replace("ebitda", NET_INCOME_TAX_AFTER_TAX)];

              // company_form[company_form_EBITDA_COMPUTED_KEY_indicators_attributes][fy--2019][value_original]
              let namespacedKey = key;
              if (netIncomeFieldName) {
                namespacedKey = key
                                .replace(NET_INCOME_TAX_AFTER_TAX, "ebitda")
                                .replace("[value", `[calculated_from][${NET_INCOME_TAX_AFTER_TAX}][value`);
              }

              const interest_income = calculatedFromfield === INTEREST_INCOME ? value : draft.inputs[namespacedKey.replace(calculatedFromfield, INTEREST_INCOME)];
              const interest_expenses = calculatedFromfield === INTERESET_EXPENSES ? value : draft.inputs[namespacedKey.replace(calculatedFromfield, INTERESET_EXPENSES)];
              const depreciation = calculatedFromfield === DEPRECIATION ? value : draft.inputs[namespacedKey.replace(calculatedFromfield, DEPRECIATION)];
              const amortization = calculatedFromfield === AMORTIZATION ? value : draft.inputs[namespacedKey.replace(calculatedFromfield, AMORTIZATION)];
              const income_tax = calculatedFromfield === INCOME_TAX ? value : draft.inputs[namespacedKey.replace(calculatedFromfield, INCOME_TAX)];

              const computedKey = namespacedKey.replace(calculatedFromfield, EBITDA_COMPUTED_KEY);

              const computedValue = (+net_income_after_tax || 0) + (+interest_expenses || 0) - (+interest_income || 0) + (+depreciation || 0) + (+amortization || 0) + (+income_tax || 0);
              draft.inputs[computedKey] = computedValue;

              if (conversionFactorToUsd) {
                convertValue(computedKey, computedValue);
              }
              // if use_compute? then also copy it over the main value_processed/origina;
            }

            if (conversionFactorToUsd) {
              draft.inputs[GLOBAL_INPUT_NAMES.currency_conversion_factor] = conversionFactorToUsd;

              if (onlyFocus) {
                return;
              }

              if (conversionFactorToUsd) {
                if (fieldName === INDICATOR_FIELD_NAME_MAP.value_original || fieldName === INDICATOR_FIELD_NAME_MAP.value_processed) {
                  convertValue(key, value);
                } else if (fieldName === INDICATOR_FIELD_NAME_MAP.indicator_unit_original_id) {
                  const updateValues = (value_original_key, value_processed_key) => {
                    const value_original = draft.inputs[value_original_key];
                    const value_processed = draft.inputs[value_processed_key];

                    // if one field is blank and another field is filled
                    if (value_original && !value_processed) {
                      draft.inputs[value_processed_key] = (value_original / conversionFactorToUsd);
                    } else if (value_processed && !value_original) {
                      draft.inputs[value_original_key] = (value_processed * conversionFactorToUsd);
                    }
                  };

                  const value_original_key = key.replace(fieldName, INDICATOR_FIELD_NAME_MAP.value_original);
                  const value_processed_key = key.replace(fieldName, INDICATOR_FIELD_NAME_MAP.value_processed);

                  updateValues(value_original_key, value_processed_key);

                  const ebitdaCurrency = calculatedFromfield === "ebitda";

                  if (ebitdaCurrency) {
                    EBITDA_COMPONENT_KEYS.map((field) => {
                      const value_original_key = key.replace("[indicator_unit_original_id]", `[calculated_from][${field}][value_original]`);
                      const value_processed_key = key.replace("[indicator_unit_original_id]", `[calculated_from][${field}][value_processed]`);

                      updateValues(value_original_key, value_processed_key);
                    });
                  }
                }
              }
            } else {
              draft.inputs[GLOBAL_INPUT_NAMES.currency_conversion_factor] = "";
            }
          }

          if (!onlyFocus) {
            if (isCalculatedFrom) {
              const computeKey = key.replace(calculatedFromfield, COMPUTE_EBITDA).replace(/\[\w+\]$/, "");
              const computeValue = +draft.inputs[computeKey] > 0;

              if (computeValue) {
                const indicatorKeyOrig = removeCalculatedFrom(key).replace(/value_\w+/, "value_original");
                const indicatorKeyProc = removeCalculatedFrom(key).replace(/value_\w+/, "value_processed");
                const computedKeyOrig = key.replace(calculatedFromfield, EBITDA_COMPUTED_KEY).replace(/value_\w+/, "value_original");
                const computedKeyProc = key.replace(calculatedFromfield, EBITDA_COMPUTED_KEY).replace(/value_\w+/, "value_processed");

                draft.inputs[indicatorKeyOrig] = draft.inputs[computedKeyOrig];
                draft.inputs[indicatorKeyProc] = draft.inputs[computedKeyProc];
              }
            } else if (calculatedFromfield === NET_INCOME_TAX_AFTER_TAX) {
              const computeKey = key.replace(NET_INCOME_TAX_AFTER_TAX, "ebitda").replace(/\[\w+\]$/, `[calculated_from][${COMPUTE_EBITDA}]`);
              const computeValue = +draft.inputs[computeKey] > 0;

              if (computeValue) {
                const indicatorKeyOrig = key.replace(NET_INCOME_TAX_AFTER_TAX, "ebitda").replace(/value_\w+/, "value_original");
                const indicatorKeyProc = key.replace(NET_INCOME_TAX_AFTER_TAX, "ebitda").replace(/value_\w+/, "value_processed");

                const computedKeyOrig = key.replace(NET_INCOME_TAX_AFTER_TAX, "ebitda").replace(/\[value_\w+/, `[calculated_from][${EBITDA_COMPUTED_KEY}][value_original`);
                const computedKeyProc = key.replace(NET_INCOME_TAX_AFTER_TAX, "ebitda").replace(/\[value_\w+/, `[calculated_from][${EBITDA_COMPUTED_KEY}][value_processed`);

                draft.inputs[indicatorKeyOrig] = draft.inputs[computedKeyOrig];
                draft.inputs[indicatorKeyProc] = draft.inputs[computedKeyProc];
              }
            }
          }
        }


        draft.inputs[key] = value;
      }));
    };
  }

  getInputValue(name, castToBool=false) {
    let base = nullUndefinedReplace(this.state.inputs[name]);

    return castToBool ? +base > 0 : base;
  }

  Input({ readOnly, name, label, type="text", doNotSubmit=false, value, blankIfFalsy=false, tooltip=false }) {
    const fixedOrStateValue = nullUndefinedReplace(value, nullUndefinedReplace(this.getInputValue(name))) || "";

    if (type === "number") {
      return [
        <input
          key="true-number"
          name={doNotSubmit ? "" : name}
          type="hidden"
          value={fixedOrStateValue}
        />,
        <NumericFormat
          key="display-number"
          className="form-control optional"
          style={{ textAlign: "right" }}
          onChange={({ target: { value } }) => this.setInputValue(name)({ target: { value: +value.replace(/,/gi, "") } })}
          onFocus={({ target: { value } }) => this.setInputValue(name, true)({ target: { value: +value.replace(/,/gi, "") } })}
          thousandSeparator
          decimalScale={2}
          fixedDecimalScale
          readOnly={readOnly}
          value={fixedOrStateValue}
          placeholder={label || name}
        />
      ];
    }

    if (type === "textarea") {
      return (
        <textarea
          className="form-control optional"
          name={doNotSubmit ? "" : name}
          type={type}
          onChange={this.setInputValue(name)}
          placeholder={label || `${name}`}
          value={fixedOrStateValue}
          readOnly={readOnly}
        />
      );
    }

    if (type === "boolean") {
      const checked = fixedOrStateValue === "1";
      const nameIfSubmit = (blankIfFalsy && !checked) || doNotSubmit ? "" : name;

      return ([
        <input
          key="unchecked-fallback"
          name={nameIfSubmit}
          type="hidden"
          value="0"
        />,
        <label key="checkbox" className="checkbox-label-center">
          <input
            className="optional"
            name={nameIfSubmit}
            type="checkbox"
            onChange={this.toggleInputValue(name)}
            placeholder={label || `${name}`}
            checked={checked}
            value="1"
            readOnly={readOnly}
          />
          {label || `${name}`}
          <i
            title=""
            style={{ paddingLeft: "2px" }}
            className={`fa fa-info-circle title-tooltip ${tooltip ? "" : "hidden"}`}
            data-bs-original-title={tooltip}
          ></i>
        </label>
      ]);
    }

    return (
      <input
        className="form-control optional"
        name={doNotSubmit ? "" : name}
        type={type}
        onChange={this.setInputValue(name)}
        placeholder={label || `${name}`}
        value={fixedOrStateValue}
        readOnly={readOnly}
      />
    );
  }

  SelectInput({ name, options=[], label, clearable=true, doNotSubmit=false, tooltip=false }) {
    const onChange = (opt) => {
      const value = opt ? opt.value : undefined;
      return (value || clearable) && this.setInputValue(name)({ target: { value } });
    };

    return (
      <div>
        <input
          name={doNotSubmit ? "" : name}
          type="hidden"
          value={this.getInputValue(name)}
        />
        <i
          title=""
          style={{ paddingLeft: "2px", display: "inline-block" }}
          className={`fa fa-info-circle title-tooltip ${tooltip ? "" : "hidden"}`}
          data-bs-original-title={tooltip}
        ></i>
        <div style={{ display: "inline-block", width: (tooltip ? "calc(100% - 20px)" : "100%"), float: (tooltip ? "right" : "none") }}>
          <Select
            className="form-control select optional react-select"
            classNamePrefix="Select"
            classNames={{ container: () => "Select__container" }}
            isClearable={clearable}
            onChange={onChange}
            options={options}
            value={options.find(o => o.value === this.getInputValue(name)) || null}
            placeholder={label || name}
            isSearchable={true}
          />
        </div>
      </div>
    );
  }

  Row(rowProps) {
    const {
      row_key,
      label,
      existing_indicators,
      rowPeriod=FY,
      rowCategory="",
      categoryIndex,
      ebitdaComponentLabel,
      ebitdaComponentKey,
    } = rowProps;
    const {
      Row,
      Input,
      SelectInput,
      getInputValue,
      addSegment,
      setCategoryValue,
      toggleInputValue,
      props: {
        options: {
          currency_options
        }
      },
      state: {
        options: {
          years,
          segments,
        },
        inputs,
      }
    } = this;

    const toggleKey = subRowToggleKey(row_key);
    const toggleValue = getInputValue(toggleKey, true);
    const updateToggleValue = toggleInputValue(toggleKey, false, true);

    const topLevelSegmentRow = segmentRowKey(row_key) && !rowCategory;

    const indicatorForYear = (columnYear) => existing_indicators.find(({ year, period, category }) => columnYear === year && rowPeriod === period && rowCategory === (category || ""));

    const ebitdaRowChild = !!ebitdaComponentLabel;
    const ebitdaRow = isEbitdaRow(row_key);
    const ebitdaRowParent = ebitdaRow && !ebitdaRowChild;

    const annualRevenueRow = row_key === "top_level_revenue" && rowPeriod === FY;
    const revenueSubrow = row_key === "top_level_revenue" && rowPeriod !== FY;
    const labelOrPeriod = rowPeriod === FY ? label : rowPeriod.toUpperCase();
    let labelOrPeriodOrCategory = labelOrPeriod;

    const drk = deletedRowKey(row_key, categoryIndex,);
    const deletedRow = getInputValue(drk, true);

    if (ebitdaRowChild) {
      labelOrPeriodOrCategory = ebitdaComponentLabel;
    }

    if (categoryIndex || categoryIndex === 0) {
      labelOrPeriodOrCategory = (
        <div className="d-flex">
          <a
            key="row-delete"
            style={{ marginRight: "3px", width: "24px" }}
            href="#"
            className={`btn btn-${deletedRow ? "primary" : "secondary"} toggle-subrows`}
            onClick={toggleInputValue(drk, false, true)}
          >
            <i className={`fa fa-${deletedRow ? "refresh" : "times"}`} />
          </a>
          <div style={{ position: "relative" }}>
            <input
              key={`category-${categoryIndex}`}
              className="form-control optional"
              disabled={deletedRow}
              name=""
              value={segments[row_key][categoryIndex]}
              onChange={setCategoryValue(row_key, categoryIndex)}
              type="text"
            />
            {
              deletedRow &&
              <div className="deleted-row-overlay">&nbsp;</div>
            }
          </div>
        </div>
      );
    }
    const defaultRow = (
      <tr key={row_key} className={classNames({ "ebitda-child-row": ebitdaRowChild, "ebitda-parent-row": ebitdaRowParent, "segment-top-row": topLevelSegmentRow, "segment-subrow": rowCategory, "revenue-subrow": revenueSubrow, hidden: (!toggleValue && (revenueSubrow || rowCategory || ebitdaRowChild)) })}>
        <td key={`td-${categoryIndex}`} colSpan={topLevelSegmentRow ? 2 : 1}>
          {
            (annualRevenueRow || topLevelSegmentRow || ebitdaRowParent) &&
            <a style={{ marginRight: "3px" }} href="#" className="btn btn-primary toggle-subrows" onClick={updateToggleValue}><i className={`fa fa-caret-${toggleValue ? (ebitdaRowParent ? "up" : "down") : "right"}`} /></a>
          }
          {labelOrPeriodOrCategory}
          {
            topLevelSegmentRow && (
              [
                <span key="span"> ({segments[row_key].length}) </span>,
                <a key="a" style={{ marginRight: "3px", width: "50px", float: "right" }} href="#" className="btn btn-primary" onClick={addSegment(row_key)}><i className="fa fa-plus-square" /></a>
              ]
            )
          }
        </td>
        {years.map((year) =>
          <DataTds
            key={year}
            year={year}
            topLevelSegmentRow={topLevelSegmentRow}
            indicatorForYear={indicatorForYear}
            getInputValue={getInputValue}
            rowPeriod={rowPeriod}
            rowCategory={rowCategory}
            segments={segments}
            categoryIndex={categoryIndex}
            row_key={row_key}
            inputs={inputs}
            Input={Input}
            SelectInput={SelectInput}
            currency_options={currency_options}
            deletedRow={deletedRow}
            ebitdaComponentKey={ebitdaComponentKey}
          />
        )}
        {
          topLevelSegmentRow ? <td key="notes_for_indicators" /> : <td key="notes_for_indicators" className={classNames({ "deleted-row-td": deletedRow, "notes-td": true })}>
            <Input
              name={`company_form[notes_for_indicators][${row_key}-${rowPeriod}-${categoryIndex}]`}
              type="textarea"
              placeholder="Notes"
            />

            {
              deletedRow &&
              <div className="deleted-row-overlay">&nbsp;</div>
            }
          </td>
        }
      </tr>
    );
    let rows = [defaultRow];

    if (annualRevenueRow) {
      PERIODS.map(period => {
        rows.push(<Row key={`${row_key}-${period}`} {...rowProps} rowPeriod={period} />);
      });
    } else if (topLevelSegmentRow) {
      segments[row_key].map((category, i) => {
        rows.push(<Row key={`${row_key}-${i}`} {...rowProps} rowCategory={category} categoryIndex={i} />);
      });
    } else if (ebitdaRowParent) {
      rows = EBITDA_COMPONENTS.map((component, i) => (
        <Row key={`${row_key}-${i}`} {...rowProps} ebitdaComponentLabel={component} ebitdaComponentKey={EBITDA_COMPONENT_KEYS[i]} />
      ));

      rows.push(<Row key={`${row_key}-computed`} {...rowProps} ebitdaComponentLabel="Computed" ebitdaComponentKey={EBITDA_COMPUTED_KEY} />);

      rows.push(defaultRow);
    }

    return rows;
  }

  getConversionFactorToUsd(year, currency_id) {
    const {
      props: {
        options: {
          currency_conversions_to_usd
        }
      },
      state: {
        inputs
      }
    } = this;
    const financial_year_end_day_month = inputs[GLOBAL_INPUT_NAMES.financial_year_end_day_month];

    if (!financial_year_end_day_month) {
      return;
    }

    const month = financial_year_end_day_month.split("/")[1];
    if (!month) {
      return;
    }

    const val = currency_conversions_to_usd[`${currency_id}-${year}-${+month}`];
    return val ? (+val) : null;
  }

  addYear(type) {
    return (e) => {
      e.preventDefault();
      e.stopPropagation();

      this.setState(
        produce((draft) => {
          if (type === ADD_NEXT_YEAR) {
            const nextYear = this.state.options.years.slice(-1)[0] + 1;
            draft.options["years"].push(nextYear);
          } else if (type === ADD_PREVIOUS_YEAR) {
            const prevYear = this.state.options.years[0] - 1;
            draft.options["years"].unshift(prevYear);
          }
        })
      );
    };
  }

  addSegment(row_key) {
    return (e) => {
      e.preventDefault();
      e.stopPropagation();

      this.setState(
        produce((draft) => {
          draft.options.segments[row_key].push("NEW");
          draft.inputs[subRowToggleKey(row_key)] = "1";
        })
      );
    };
  }

  render() {
    const {
      Input,
      SelectInput,
      Row,
      addYear,
      props: {
        options: {
          currency_options,
          start_year,
          size_range,
          // currency_conversions_to_usd,
        }
      },
      state: {
        options: {
          rows,
          years
        }
      }
    } = this;
    const currency_conversion_factor = this.state.inputs[GLOBAL_INPUT_NAMES.currency_conversion_factor];

    const override_indicator_size_range = this.state.inputs[GLOBAL_INPUT_NAMES.override_indicator_size_range];
    const override_indicator_top_level_revenue_range = this.state.inputs[GLOBAL_INPUT_NAMES.override_indicator_top_level_revenue_range];

    let latestWaterRevenueRange, revenueRangeYear, latestTopLevelRevenueRange, topLevelRevenueRangeYear;
    [...years].reverse().find((year) => {
      revenueRangeYear = year;
      latestWaterRevenueRange = this.getInputValue(nsIndicator("water_revenue", indicatorStateId({ categoryIndex: "", period: "fy", year }), "value_processed"));

      return latestWaterRevenueRange;
    });
    [...years].reverse().find((year) => {
      topLevelRevenueRangeYear = year;
      latestTopLevelRevenueRange = this.getInputValue(nsIndicator("top_level_revenue", indicatorStateId({ categoryIndex: "", period: "fy", year }), "value_processed"));

      return latestTopLevelRevenueRange;
    });
    const overridingIndicatorSize = override_indicator_size_range === "1" || !latestWaterRevenueRange;
    const overridingIndicatorTopLevelRevenue = override_indicator_top_level_revenue_range === "1" || !latestTopLevelRevenueRange;

    const sizeRangeValue = this.state.inputs[GLOBAL_INPUT_NAMES.size_range];
    const topLevelRevenueRangeValue = this.state.inputs[GLOBAL_INPUT_NAMES.top_level_revenue_range];

    const sizeRangeOptionBeingUsed = overridingIndicatorSize ? sizeRangeValue : waterRevenueToSizeRangeValue(latestWaterRevenueRange);
    const topLevelRevenueRangeOptionBeingUsed = overridingIndicatorTopLevelRevenue ? topLevelRevenueRangeValue : waterRevenueToSizeRangeValue(latestTopLevelRevenueRange);

    const sizeRangeBeingUsed = (size_range.find(e => e.value === sizeRangeOptionBeingUsed) || {}).label || "n/a";
    const topLevelRevenueRangeBeingUsed = (size_range.find(e => e.value === topLevelRevenueRangeOptionBeingUsed) || {}).label || "n/a";

    const yearOrOverride = overridingIndicatorSize ? "override" : revenueRangeYear;
    const yearOrOverrideTopLevelRevenue = overridingIndicatorTopLevelRevenue ? "override" : topLevelRevenueRangeYear;

    const previousYear = years[0] - 1;
    const nextYear = years.slice(-1)[0] + 1;

    return (
      <div className="react-indicator-app-wrapper">
        <div className="inputs row" style={{ zIndex: 2 }}>
          <div className="col-lg-3">
            <ButtonWithModal buttonLabel="How do I use the 'Financial Data' section?">
              <p>First input financial year end and the currency for any years applicable to entry. This will ensure that when entering data currency conversions are completed automatically.</p>
              <p>To enter quarterly and interim revenue data click the arrow to the left of the revenue cell.</p>
              <p>If you can’t get an EBITDA figure directly, click the arrow next to the EBITDA cell to open up rows for manual calculation.</p>
              <p>When adding business or geographical segments you will need to type the name of the segment in the ‘NEW’ cell.</p>
              <p>Add new blank years using the Add buttons in the top right hand corner of the table.</p>
            </ButtonWithModal>
          </div>
          <div className="col-lg-9">
            <Input name={baseNS("hide_financial_data")} type="boolean" label="Hide financial data cards?" tooltip="Tick this if you want to hide financial data cards from the company profile." />
          </div>
          <div className="col-lg-4">
            <Input name={GLOBAL_INPUT_NAMES.override_indicator_size_range} type="boolean" label="Ignore indicator size range?" tooltip="A water revenue range is automatically generated from data in the table. Tick this box to ignore this and edit the range manually." />
          </div>
          <div style={{ transition: "visibility 0.2s ease-in-out" }} className={classNames({ "d-flex": true, "col-lg-3": true, hidden: !overridingIndicatorSize })}>
            <div style={{ width: "75%" }}>
              <SelectInput
                doNotSubmit={!overridingIndicatorSize}
                name={GLOBAL_INPUT_NAMES.size_range}
                label="Size range"
                tooltip="Indicates a range within which the company’s water revenue is most likely to exist. Water revenue refers to any revenue generated from activities within the water sector, including selling treatment technologies, building infrastructure, or providing chemicals."
                options={size_range}
              />
            </div>
            <div style={{ width: "25%" }}>
              <Input
                doNotSubmit={!overridingIndicatorSize}
                name={baseNS("size_year")}
                label="Year"
              />
            </div>
          </div>
          <div className="col-lg-5">
            <b>Size range being used</b>: {sizeRangeBeingUsed} ({yearOrOverride})
          </div>
        </div>
        <div className="inputs row" style={{ zIndex: 2 }}>
          <div className="col-lg-4">
            <Input name={GLOBAL_INPUT_NAMES.override_indicator_top_level_revenue_range} type="boolean" label="Ignore indicator top level revenue range?" tooltip="A top level revenue range is automatically generated from the data in the table. Tick this box to ignore this and edit the range manually." />
          </div>
          <div style={{ transition: "visibility 0.2s ease-in-out" }} className={classNames({ "d-flex": true, "col-lg-3": true, hidden: !overridingIndicatorTopLevelRevenue })}>
            <div style={{ width: "75%" }}>
              <SelectInput
                doNotSubmit={!overridingIndicatorTopLevelRevenue}
                name={GLOBAL_INPUT_NAMES.top_level_revenue_range}
                label="Top level revenue range"
                options={size_range}
                tooltip="Indicates a range within which the company’s top-level revenue is most likely to exist."
              />
            </div>
            <div style={{ width: "25%" }}>
              <Input
                doNotSubmit={!overridingIndicatorTopLevelRevenue}
                name={baseNS("top_level_revenue_year")}
                label="Year"
              />
            </div>
          </div>
          <div className="col-lg-5">
            <b>Revenue range being used</b>: {topLevelRevenueRangeBeingUsed} ({yearOrOverrideTopLevelRevenue})
          </div>
        </div>

        <div className="row">
          <div className="col-lg-2" style={{ padding: 0 }}>
            <Input name={GLOBAL_INPUT_NAMES.financial_year_end_day_month} label="FYE (Day / Month)" />
          </div>
          <div className="col-lg-7">
            <b>Currency conversion factor</b>: {currency_conversion_factor || "N/A"}
          </div>
          <div className="col-lg-9">
            <div className="row">
              <div className="col-lg-2">
              <b>Size description: </b>
              </div>
              <div className="col-lg-5">
                <Input name={GLOBAL_INPUT_NAMES.size_description} type="text" label="Size description" tooltip="Reported or Estimated" />
              </div>
            </div>
          </div>
          <div className="col-lg-2 col-lg-offset-1 d-flex" style={{ justifyContent: "flex-end", paddingRight: 0 }}>
            <a style={{ marginRight: "3px" }} href="#" className="btn btn-primary" onClick={addYear(ADD_PREVIOUS_YEAR)}>&lt; Add {previousYear}</a>
            <a href="#" className="btn btn-primary" onClick={addYear(ADD_NEXT_YEAR)}>Add {nextYear} &gt;</a>
          </div>
        </div>

        <div className="react-indicator-table-wrapper row">
          <div className="col-lg-12">
            <table className="table table-bordered react-indicator-table">
              <thead>
                <tr>
                  <th>
                    <div className="d-flex" style={{ justifyContent: "space-between" }}>
                      <div style={{ flex: 1 }} className="hidden">
                        <SelectInput name={GLOBAL_INPUT_NAMES.default_currency_id} label="Currency" options={currency_options} />
                      </div>
                      <div style={{ flex: 1 }}>
                        <Input name={GLOBAL_INPUT_NAMES.custom_conversion_factor} label="Conversion" />
                      </div>
                    </div>
                    <div className="d-flex hidden" style={{ justifyContent: "space-between" }}>
                      <div className="hidden" style={{ flex: 1 }}>
                        <SelectInput
                          name={GLOBAL_INPUT_NAMES.global_multiplier}
                          label="values are ..."
                          options={GLOBAL_MULTIPLIER_OPTIONS}
                          resetValue={GLOBAL_MULTIPLIER_OPTIONS[0]}
                        />
                      </div>
                    </div>
                  </th>
                  {
                    years.map(year => (
                      <th key={year} className={classNames({ startYear: start_year === year })} style={{ width: "200px" }}>
                        <div className="d-flex" style={{ justifyContent: "center", width: "200px" }}>
                          <div style={{ flex: 1 }}>
                            {year}
                          </div>
                          <div style={{ flex: 1 }}>
                            <SelectInput doNotSubmit name={defaultCurrencyKey(year)} label="Currency" options={currency_options} />
                          </div>
                        </div>
                        <div className="d-flex" style={{ justifyContent: "space-between" }}>
                          <div className="hidden" style={{ flex: CURRENCY_FLEX }}>Currency</div>
                          <div style={{ flex: 1 }}>Value</div>
                          <div style={{ flex: 1 }}>USD</div>
                        </div>
                      </th>
                    ))
                  }
                  <th id="notes">
                    <div className="d-flex" style={{ width: "150px", justifyContent: "center" }}>
                      <span>Notes  <i title="" className="fa fa-info-circle title-tooltip" data-bs-original-title="Leave notes about the data, either important details, or text describing any sudden changes or anomalies which may confuse analysts wanting to use the data in the future."></i></span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {
                  rows.map(e => <Row key={e.row_key} {...e} />)
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

Root.propTypes = {
  options: PropTypes.shape({
    currency_options: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, value: PropTypes.number })),
    years: PropTypes.arrayOf(PropTypes.number),
    start_year: PropTypes.number,
    currency_conversions_to_usd: PropTypes.object,
    rows: PropTypes.arrayOf(PropTypes.shape({
      row_key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      indicator_data_type_id: PropTypes.number.isRequired,
      categories: PropTypes.arrayOf(PropTypes.string),
      existing_indicators: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        // aggregate_id: PropTypes.number,
        indicator_data_type_id: PropTypes.number,
        value_original: PropTypes.number,
        indicator_unit_original_id: PropTypes.number,
        value_processed: PropTypes.number,
        indicator_unit_processed_id: PropTypes.number,
        // source_detail_id: PropTypes.number,
        // indicator_name_id: PropTypes.number,
        year: PropTypes.number,
        notes: PropTypes.string,
        category: PropTypes.string,
        // created_at: PropTypes.date,
        // updated_at: PropTypes.date,
        // period_type: PropTypes.string,
        period: PropTypes.string,
        // period_end_date: PropTypes.date,
        size_range: PropTypes.string,
        size_description: PropTypes.string,
        // industrial_sector_id: PropTypes.number,
        // industrial_end_user_subsector_id: PropTypes.number,
        calculated_from: PropTypes.object
      })),
    })),
  }),
  inputs: PropTypes.shape({
    financial_year_end_day_month: PropTypes.string,
    override_indicator_size_range: PropTypes.bool,
    size_range: PropTypes.string,
    size_description: PropTypes.string,
    size_year: PropTypes.number,
    override_indicator_top_level_revenue_range: PropTypes.bool,
    hide_financial_data: PropTypes.bool,
    top_level_revenue_range: PropTypes.string,
    top_level_revenue_year: PropTypes.number,
    notes_for_indicators: PropTypes.shape({}),
  }),
};

export default Root;
